<template>
  <div>
    <!-- 结束作业 -->
    <Modal v-model="isFinish" v-if="isFinishStatus" width="1200" :title="$t('key1004853')" :styles="{ top: '100px' }">
      <!-- 无异常 -->
      <div v-if="endStatus">
        <div style="height:60px;paddingLeft:10px;marginBottom:20px;border:1px solid #ccc;background:#ffffcc;lineHeight:60px;font-size:16px;font-weight:bold;">
          {{ $t('key1004854').replace('{pickingGoodsNo}', pickInfo.code) }}
        </div>
        <Table border max-height="138" :columns="countDataColumn" :data="countData"></Table>
        <div style="marginTop:20px;">
          {{ $t('key1004855').replace('{scannedCount}', scannedCount) }}，
          {{ $t('key1004856').replace('{scannedTime}', scannedTime) }}，
          {{ $t('key1004857').replace('{userScannedTime}', userScannedTime) }}
        </div>
        <Table border :columns="userDataColumn" :data="userData"></Table>
      </div>
      <!-- 有异常 -->
      <div v-if="!endStatus">
        <div style="height:60px;paddingLeft:10px;marginBottom:20px;border:1px solid #ccc;background:#ffffcc;lineHeight:60px;font-size:16px;font-weight:bold;">
          {{ $t('key1004858').replace('{pickingGoodsNo}', pickingGoodsNo) }}：
        </div>
        <div v-if="printData.length > 0" style="height:320px;border:1px solid #ccc;background:#d6e9f2;marginTop:20px;">
          <Row>
            <Col span="15" style="marginLeft:10px;">
              <Row>
                <Col span="20">
                  <span style="color:#ff0000;">{{ $t('key1004859') }}</span>
                </Col>
                <Col span="4">
                  <span style="cursor:pointer;" @click="importExcel(0)">{{ $t('key1004860') }}</span>
                </Col>
              </Row>
              <Table border height="200" :columns="printDataColumn" :data="printData"></Table>
            </Col>
            <Col span="8" style="marginLeft:20px;">
              <span style="cursor:pointer;" @click="importExcel(1)">{{ $t('key1004860') }}</span>
              <Table border max-height="200" :columns="printGoodsDataColumn" :data="printGoodsData"></Table>
            </Col>
          </Row>
          <div style="marginTop:20px;marginLeft:10px;fontSize:14px;">
            <div>{{ $t('key1004861') }}</div>
            <div>{{ $t('key1004862') }}</div>
            <div>{{ $t('key1004863') }}</div>
          </div>
        </div>
        <div v-if="cancelData.length > 0" style="height:320px;border:1px solid #ccc;background:#d6e9f2;marginTop:20px;">
          <Row>
            <Col span="15" style="marginLeft:10px;">
              <Row>
                <Col span="20">
                  <span style="color:#ff0000;">{{ $t('key1004864') }}</span>
                </Col>
                <Col span="4">
                  <span style="cursor:pointer;" @click="startImportExcel(0)">{{ $t('key1004860') }}</span>
                </Col>
              </Row>
              <Table border max-height="200" :columns="cancelDataColumn" :data="cancelData"></Table>
            </Col>
            <Col span="8" style="marginLeft:20px;">
              <span style="cursor:pointer;" @click="startImportExcel(1)">{{ $t('key1004860') }}</span>
              <Table border max-height="200" :columns="cancelGoodsDataColumn" :data="cancelGoodsData"></Table>
            </Col>
          </Row>
          <div style="marginTop:20px;marginLeft:10px;fontSize:14px;">
            <div>{{ $t('key1004865') }}</div>
            <div>{{ $t('key1004866') }}</div>
            <div>{{ $t('key1004867') }}</div>
          </div>
        </div>
        <div v-if="cancelPrintData.length > 0" style="height:320px;border:1px solid #ccc;background:#d6e9f2;marginTop:20px;">
          <Row>
            <Col span="15" style="marginLeft:10px;">
              <Row>
                <Col span="20">
                  <span style="color:#ff0000;">{{ $t('key1004868') }}</span>
                </Col>
                <Col span="4">
                  <span style="cursor:pointer;" @click="endImportExcel(0)">{{ $t('key1004860') }}</span>
                </Col>
              </Row>
              <Table border height="200" :columns="cancelPrintColumn" :data="cancelPrintData"></Table>
            </Col>
            <Col span="8" style="marginLeft:20px;">
              <span style="cursor:pointer;" @click="endImportExcel(1)">{{ $t('key1004860') }}</span>
              <Table border height="200" :columns="cancelPrintGoodsColumn" :data="cancelPrintGoodsData"></Table>
            </Col>
          </Row>
          <div style="marginTop:20px;marginLeft:10px;fontSize:14px;">
            <div>{{ $t('key1004869') }}</div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button v-if="endStatus && getPermission('ymsPickingOrder_endPacking')" type="primary" @click="finishPackWork(0)">{{ $t('key1004870') }} </Button>
        <Button v-if="!endStatus && getPermission('ymsPickingOrder_endPacking')" type="error" @click="finishPackWork(1)">{{ $t('key1004002') }} </Button>
        <Button v-if="!endStatus" type="primary" @click="backPacking">{{ $t('key1004871') }} </Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import {getUserInfoByUserIdsData, getWarehouseId} from "@/utils/common";

export default {
  mixins: [Mixin],
  props: ['pickingGoodsNo', 'pickingGoodsId', 'currentPackageData', 'pickInfo', 'userData'],
  data() {
    let v = this;
    return {
      original_data: [],
      row_packageCode: [],
      columns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode'
        },
        {
          title: 'SKU',
          key: 'sku'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000242'),
          key: 'doneAssignedNumber'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620'),
          key: 'wmsLocationList',
          render(h, params) {
            let arr = params.row.wmsLocationList && params.row.wmsLocationList.length > 0
              ? params.row.wmsLocationList
              : [];
            return h('div', {}, arr.map(i => h('span', i)));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004835'),
          key: 'actualPickingNumber',
          render(h, params) {
            return h('InputNumber', {
              props: {
                value: 0,
                min: 0,
                max: v.data[params.index].doneAssignedNumber
              },
              on: {
                'on-change'(value) {
                  v.data1[params.index].actualPickingNumber = value;
                  v.data2[params.row.packageGoodsId] = value;
                  v.data[params.index].unselectedQuantity = v.data[params.index].doneAssignedNumber - v.data1[params.index].actualPickingNumber;
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004836'),
          key: 'unselectedQuantity'
        }
      ],
      data: [],
      data1: [],
      data2: {},
      isFinish: false,
      isFinishStatus: false,
      endStatus: false, // 控制展示显示正常结束信息或是异常结束信息
      countData: [// 结束作业无异常 统计项目数据
        {
          countName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004837'),
          allPackTotalCount: null,
          packedCount: null
        }, {
          countName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004838'),
          allPackTotalCount: null,
          packedCount: null
        }
      ],
      countDataColumn: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004839'),
          key: 'countName',
          align: 'center'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004840'),
          key: 'allPackTotalCount',
          align: 'center'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004841'),
          key: 'packedCount',
          align: 'center'
        }
      ],
      scannedCount: 0, // 本次拣货复核人数
      scannedTime: 0, // 总时间
      userScannedTime: 0, // 人工时
      userDataColumn: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004842'),
          key: 'userName',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004843'),
          key: 'packageTotalCount',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003630'),
          key: 'goodsTotalCount',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004844'),
          key: 'scannedTime',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004845'),
          key: '',
          align: 'center',
          render: (h, params) => {
            let num = params.row.packageTotalCount / params.row.scannedTime;
            return h('div', num.toFixed(2));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004846'),
          key: '',
          align: 'center',
          render: (h, params) => {
            let num = params.row.goodsTotalCount / params.row.scannedTime;
            return h('div', num.toFixed(2));
          }
        }
      ],
      printChioseData: [], // 已打印包裹code
      unPrintChioseData: [], // 未打印包裹code
      rowChioseNum: 0,
      headChioseNum: 0,
      printRowChioseNum: 0,
      pringtHeadChioseNum: 0,
      printData: [], // 结束作业有异常 正在打印中的数据
      printDataColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center',
          render(h, params) {
            return h('span', params.row.ymsPackageInfo.trackingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004847'),
          key: 'buyerName',
          align: 'center',
          render(h, params) {
            return h('span', params.row.ymsPackageInfo.buyerName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004848'),
          key: 'scannedTime',
          align: 'center',
          render: (h, params) => {
            let date = this.$uDate.dealTime(params.row.scannedTime);
            return h('div', date);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 150,
          align: 'center',
          renderHeader: (h, params) => {
            return h('RadioGroup', {
              props: {
                value: this.pringtHeadChioseNum
              },
              on: {
                'on-change': value => {
                  v.printData.forEach((i, index) => {
                    v.$set(v.printData[index], 'rowChioseNum', value);
                  });
                  v.printRowChioseNum = value;
                }
              }
            }, [
              h('Radio', {
                style: {
                  color: '#378000'
                },
                props: {
                  label: 1
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000790')), h('Radio', {
                style: {
                  color: '#ff0000'
                },
                props: {
                  label: 0
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000790'))
            ]);
          },
          render: (h, params) => {
            return h('RadioGroup', {
              props: {
                value: this.printRowChioseNum
              },
              on: {
                'on-change': value => {
                  v.$set(v.printData[params.index], 'rowChioseNum', value);
                }
              }
            }, [
              h('Radio', {
                style: {
                  color: '#378000'
                },
                props: {
                  label: 1
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004849')), h('Radio', {
                style: {
                  color: '#ff0000'
                },
                props: {
                  label: 0
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004850'))
            ]);
          }
        }
      ],
      printGoodsData: [], // 正在打印中的货品小计
      printGoodsDataColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
          key: 'sku',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          align: 'center'
        }
      ],
      cancelData: [], // 打印前作废的包裹信息
      cancelDataColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center',
          render(h, params) {
            return h('span', params.row.ymsPackageInfo.trackingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004847'),
          key: 'buyerName',
          align: 'center',
          render(h, params) {
            return h('span', params.row.ymsPackageInfo.buyerName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004852'),
          key: '',
          align: 'center',
          render: (h, params) => {
            return h('div', {}, params.row.ymsPackageInfo.ymsPackageGoods.map(i => h('p', i.sku + '*' + i.quantity)));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 150,
          align: 'center',
          renderHeader: (h, params) => {
            return h('RadioGroup', {
              props: {
                value: this.headChioseNum
              },
              on: {
                'on-change': value => {
                  this.changeChiose(value);
                }
              }
            }, [
              h('Radio', {
                style: {
                  color: '#378000'
                },
                props: {
                  label: 1
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000790')), h('Radio', {
                style: {
                  color: '#ff0000'
                },
                props: {
                  label: 0
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000790'))
            ]);
          },
          render: (h, params) => {
            return h('RadioGroup', {
              props: {
                value: this.rowChioseNum
              },
              on: {
                'on-change': value => {
                  this.rowChioseChange(value, params.index);
                }
              }
            }, [
              h('Radio', {
                style: {
                  color: '#378000'
                },
                props: {
                  label: 1
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004849')), h('Radio', {
                style: {
                  color: '#ff0000'
                },
                props: {
                  label: 0
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004850'))
            ]);
          }
        }
      ],
      cancelGoodsData: [], // 打印前作废sku
      cancelGoodsDataColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
          key: 'sku',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          align: 'center'
        }
      ],
      cancelPrintData: [], // 打印后作废的包裹信息
      cancelPrintColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center',
          render(h, params) {
            return h('span', params.row.ymsPackageInfo.trackingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004847'),
          key: 'buyerName',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004852'),
          key: '',
          align: 'center',
          render: (h, params) => {
            let pos = [];
            if (this.cancelPrintData) {
              this.cancelPrintData.forEach((n, i) => {
                if (n.packageCode === params.row.packageCode) {
                  let item = h('div', [h('div', n.sku + ' * ' + n.quantity)]);
                  pos.push(item);
                }
              });
              return h('div', pos);
            }
          }
        }
      ],
      cancelPrintGoodsData: [], // 打印后作废的sku
      cancelPrintGoodsColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
          key: 'sku',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          align: 'center'
        }
      ],
      userList: [] // 作业人
    };
  },
  methods: {
    PrintDistributionList() {
      /**
       * 打印配货清单
       * */
      let v = this;
      let obj = {
        packageCodeList: v.data.map(i => i.packageCode),
        warehouseId: getWarehouseId()
      };
      v.$Spin.show();
      v.axios.post(api.post_packageInfo_queryDeliveryListPath, obj).then(response => {
        v.$Spin.hide();
        if (response.data.code === 0) {
          let data = response.data.datas;
          data.every((n, i) => {
            v.commonPrint(n.deliveryListLabelPath, n.packageCode);
            return true;
          });
        }
      });
    },
    initData() {
      let v = this;
      if (v.endStatus) {
        // 无异常
        v.printGoodsData = [];
        v.countData[0].allPackTotalCount = v.pickInfo.ymsPickingOrderRelatedList.length; // 拣货单所有包裹数量
        v.countData[0].packedCount = v.pickInfo.ymsPickingOrderRelatedList.reduce((a, b) => {
          if (b.packedStatus === 3) {
            return ++a;
          } else {
            return a;
          }
        }, 0); // 拣货单已完成拣货复核包裹数量
        v.countData[1].allPackTotalCount = v.pickInfo.ymsPickingOrderRelatedList.reduce((a, b) => {
          b.ymsPackageInfo.ymsPackageGoods.forEach(i => {
            a = a + i.quantity;
          });
          return a;
        }, 0); // 拣货单所有货品总数
        v.countData[1].packedCount = v.pickInfo.ymsPickingOrderRelatedList.reduce((a, b) => {
          if (b.packedStatus === 3) {
            b.ymsPackageInfo.ymsPackageGoods.forEach(i => {
              a = a + i.quantity;
            });
          }
          return a;
        }, 0); // 拣货单完成扫描货品数量
        v.$nextTick(() => {
          let obj = {};
          let userObj = {};
          let userNumber = 0;
          v.pickInfo.ymsPickingOrderRelatedList.forEach(i => {
            i.ymsPackageInfo.ymsPackageGoods.forEach(j => {
              if (!userObj[i.matchedBy]) {
                userObj[i.matchedBy] = true;
                userNumber++;
              }
              if (obj[j.sku]) {
                obj[j.sku].quantity = obj[j.sku].quantity + j.quantity;
              } else {
                obj[j.sku] = j.quantity;
              }
            });
          });
          for (let key in obj) {
            v.printGoodsData.push({
              sku: key,
              quantity: obj[key]
            });
          }
          v.scannedCount = userNumber;
          v.userScannedTime = v.userData.reduce((a, b) => {
            return a + Number(b.scannedTime);
          }, 0);
          let packStartTime = v.userData[0].startTime;
          v.userData.forEach(i => {
            if (packStartTime > i.startTime) {
              packStartTime = i.startTime;
            }
          });
          if (packStartTime) {
            v.scannedTime = ((new Date().getTime() - new Date(v.$uDate.getDataToLocalTime(packStartTime, 'fulltime')).getTime()) / (1000 * 60)).toFixed(2);
          }
        });
      } else {
        // 异常
        v.cancelData = [];
        v.printData = [];
        v.cancelGoodsData = [];
        let obj = {};
        v.pickInfo.ymsPickingOrderRelatedList.forEach(i => {
          //  1:待包装 2:包装中 3:包装完成'
          if (i.packedStatus === 1 || i.packedStatus === 2) {
            i.ymsPackageInfo.ymsPackageGoods.forEach(j => {
              if (obj[j.sku]) {
                obj[j.sku].quantity += j.quantity;
              } else {
                obj[j.sku] = {
                  quantity: j.quantity
                };
              }
            });
          }
          if (i.packedStatus === 1) {
            i.rowChioseNum = 0;
            v.cancelData.push(i);
          }
          if (i.packedStatus === 2) {
            i.rowChioseNum = 0;
            v.printData.push(i);
          }
        });
        v.pringtHeadChioseNum = 1;
        v.headChioseNum = 1;
        v.rowChioseNum = 1;
        v.printRowChioseNum = 1;
        v.$nextTick(() => {
          v.headChioseNum = 0;
          v.rowChioseNum = 0;
          v.pringtHeadChioseNum = 0;
          v.printRowChioseNum = 0;
        });
        for (let key in obj) {
          v.cancelGoodsData.push({
            sku: key,
            quantity: obj[key].quantity
          });
        }
      }
    },
    normalData() {
      // 获取正常的结束展示信息
      let v = this;
      let pos = [];
      v.axios.get(api.get_wmsPickingGoods_statisticsPacking + v.pickingGoodsId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          // console.log(data);
          v.countData[0].allPackTotalCount = data.packageTotalCount; // 拣货单所有包裹数量
          v.countData[0].packedCount = data.packedPackageCount; // 拣货单已完成拣货复核包裹数量
          v.countData[1].allPackTotalCount = data.goodsTotalCount; // 拣货单所有货品总数
          v.countData[1].packedCount = data.packedGoodsCount; // 拣货单完成扫描货品数量
          v.scannedCount = data.scannedCount; // 本次拣货复核人数
          v.scannedTime = data.scannedTime; // 包装总时间
          v.userScannedTime = data.userScannedTime; // 人工时
          data.scannerDetails.forEach((n, i) => {
            pos.push(n.userId);
          });
          if (pos.length > 0) {
            getUserInfoByUserIdsData(pos, v).then((userData) => {
              v.userList = userData;
              v.userData = data.scannerDetails; // 扫描员扫描详情
            });
          }
        }
      });
    },
    abnormalData() {
      // 获取异常的结束展示信息
      let v = this;
      v.row_packageCode = [];
      v.axios.get(api.get_wmsPickingGoods_getPackingWarnPackages + v.pickingGoodsId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.printData = data.printingPackages; // 打印中的包裹信息
          v.printGoodsData = data.printingSkus; // 打印中的sku
          v.cancelData = data.unprintPackages; // 作废的的包裹信息
          v.cancelGoodsData = data.unprintSkus; // 作废的的包裹sku
          v.cancelPrintData = data.invalidPackages; // 打印后作废的包裹
          v.cancelPrintGoodsData = data.invalidSkus; // 打印后作废的sku
          v.data = data.waitPrintSuccessSkus.map(i => {
            i.unselectedQuantity = i.doneAssignedNumber;
            // v.currentPackageData.forEach(j => {
            //   if (i.sku === j.sku) {
            //     i.unselectedQuantity = i.doneAssignedNumber - j.scanQuantity;
            //   }
            // });
            return i;
          }).filter(i => i.unselectedQuantity > 0); // 未拣货/打印出库单明细
          v.original_data = v.data;
          v.data1 = data.waitPrintSuccessSkus.map(i => {
            return {
              packageGoodsId: i.packageGoodsId,
              actualPickingNumber: 0
            };
          }); // 未拣货/打印出库单明细
          let new_data = [];
          if (v.headChioseNum === 1) {
            let packageCode_arr = [];
            v.printData.map((ele) => {
              packageCode_arr.push(ele.packageCode);
            });

            v.data.map((item) => {
              if (packageCode_arr.indexOf(item.packageCode) <= -1) {
                new_data.push(item);
              }
            });
          }
          v.data = new_data;
        }
      });
    },
    rowChioseChange(value, index) {
      let v = this;
      v.$set(v.cancelData[index], 'rowChioseNum', value);
    },
    changeChiose(value) {
      let v = this;
      v.cancelData.forEach((i, index) => {
        v.$set(v.cancelData[index], 'rowChioseNum', value);
      });
      this.rowChioseNum = value;
    },
    allChiose(val) {
      let v = this;
      // 先清空，防止点全选前点过单个
      v.printChioseData = [];
      v.unPrintChioseData = [];
      v.headChioseNum = val;
      if (val) {
        // 0未打 1已打
        v.rowChioseNum = 1;
        let pos = [];
        v.printData.forEach((n, i) => {
          pos.push(n.packageCode);
        });
        v.printChioseData = pos;

        let new_data = [];
        if (v.headChioseNum === 1) {
          let packageCode_arr = [];
          v.printData.map((ele) => {
            packageCode_arr.push(ele.packageCode);
          });

          v.original_data.map((item) => {
            if (packageCode_arr.indexOf(item.packageCode) <= -1) {
              new_data.push(item);
            }
          });
        }
        v.data2 = {};
        v.data = new_data;
      } else {
        v.rowChioseNum = 0;
        let box = [];
        v.printData.forEach((n, i) => {
          box.push(n.packageCode);
        });
        v.unPrintChioseData = box;
        v.data = v.original_data;
      }
    },
    rowChiose(val, index) {
      let v = this;
      // 判断是否点过全选，若有则需改值和状态
      if (v.headChioseNum !== null) {
        if (val !== v.headChioseNum) {
          v.headChioseNum = null;
        } else {
          return false;
        }
      }
      if (val) {
        // 0未打 1已打
        v.printChioseData.push(v.printData[index].packageCode);
        // 若当前code为已打，则需判断未打中是否有这个code，有则移除（改变状态时用到）
        if (v.unPrintChioseData.indexOf(v.printData[index].packageCode) !== -1) {
          let pid = v.unPrintChioseData.indexOf(v.printData[index].packageCode);
          v.unPrintChioseData.splice(pid, 1);
        }

        let new_data = [];
        v.row_packageCode.push(v.printData[index].packageCode);
        v.original_data.map((item) => {
          if (v.row_packageCode.indexOf(item.packageCode) <= -1) {
            new_data.push(item);
          }
        });
        v.data2 = {};
        v.data = new_data;
      } else {
        v.original_data.map((item) => {
          if (item.packageCode === v.printData[index].packageCode) {
            v.data.push(item);
            v.row_packageCode.splice(index, 1);
          }
        });
        v.unPrintChioseData.push(v.printData[index].packageCode);
        // 若当前code为未打，则需判断已打中是否有这个code，有则移除（改变状态时用到）
        if (v.printChioseData.indexOf(v.printData[index].packageCode) !== -1) {
          let uid = v.printChioseData.indexOf(v.printData[index].packageCode);
          v.printChioseData.splice(uid, 1);
        }
      }
      if (v.printChioseData.length === v.printData.length) {
        v.headChioseNum = 1;
      } else if (v.unPrintChioseData.length === v.printData.length) {
        v.headChioseNum = 0;
      }
    },
    finishPackWork() {
      // 结束作业
      let v = this;
      v.pickInfo.ymsPickingOrderRelatedList.forEach(i => {
        v.cancelData.forEach(j => {
          if (i.ymsPickingOrderRelatedId === j.ymsPickingOrderRelatedId) {
            i.rowChioseNum = j.rowChioseNum;
          }
        });
      });
      let obj = {
        "packedYmsPackageIds": v.pickInfo.ymsPickingOrderRelatedList.filter(i => i.packedStatus === 3 || i.rowChioseNum === 1).map(i => i.ymsPackageId), // 已包装
        "unpackedYmsPackageIds": v.pickInfo.ymsPickingOrderRelatedList.filter(i => (i.packedStatus === 1 || i.packedStatus === 0 || i.packedStatus === 2) && i.rowChioseNum !== 1).map(i => i.ymsPackageId), // 未包装
        "ymsPickingOrderId": v.pickInfo.ymsPickingOrderId
      };
      v.axios.put(api.put_ymsPickingOrder_endPacking, obj).then(response => {
        if (response.data.code === 0) {
          v.$router.push('/wms/packWorking');
          v.printChioseData = [];
          v.unPrintChioseData = [];
        }
      });
    },
    backPacking() {
      // 返回继续包装
      let v = this;
      v.isFinish = false;
      v.headChioseNum = 1;
      v.rowChioseNum = 1;
      v.printChioseData = [];
      v.unPrintChioseData = [];
    },
    importExcel(val) {
      // 正在打印 导出
      let v = this;
      let obj = {};
      let filenodeViewTargetUrl = localStorage.getItem('imgUrlPrefix');
      if (val) {
        // printGoodsData
        if (!v.printGoodsData) {
          v.$Message.error('no data！');
          return false;
        }
        // 组装数据
        let excelContentList = []; // 数据
        let excelTitleList = [// 表头
          {
            title: 'No',
            column: 'no'
          },
          {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
            column: 'goodsTotal'
          },
          {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
            column: 'goodsNum'
          }
        ];
        let pos = [];
        v.printGoodsData.forEach((n, i) => {
          pos.push([
            {
              column: 'no',
              content: i + 1
            },
            {
              column: 'goodsTotal',
              content: n.sku
            },
            {
              column: 'goodsNum',
              content: n.quantity
            }
          ]);
        });
        pos.forEach((m, t) => {
          excelContentList.push({
            excelColumnContentList: m
          });
        });
        obj = {
          excelContentList: excelContentList,
          excelTitleList: excelTitleList
        };
        let newTab = window.open('about:blank');
        v.axios.post(api.post_packageGoods_exportPackingPrintingSkusExcel, obj).then(response => {
          if (response.data.code === 0) {
            newTab.location.href = filenodeViewTargetUrl + response.data.datas;
            setTimeout(function () {
              newTab.close();
            }, 1000);
          } else {
            newTab.close();
          }
        });
      } else {
        if (!v.printData.length) {
          v.$Message.error('no data！');
          return false;
        }
        // 组装数据
        let excelContentList = []; // 数据
        let excelTitleList = [// 表头
          {
            title: 'No',
            column: 'no'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000156'),
            column: 'pickNo'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
            column: 'followNo'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004847'),
            column: 'buyerName'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004848'),
            column: 'time'
          }
        ];
        let pos = [];
        // let box = [];
        v.printData.forEach((n, i) => {
          let date = this.$uDate.dealTime(n.scannedTime);
          pos.push([
            {
              column: 'no',
              content: i + 1
            }, {
              column: 'pickNo',
              content: n.packageCode
            }, {
              column: 'followNo',
              content: n.trackingNumber
            }, {
              column: 'buyerName',
              content: n.buyerName
            }, {
              column: 'time',
              content: date
            }
          ]);
        });
        pos.forEach((m, t) => {
          excelContentList.push({
            excelColumnContentList: m
          });
        });
        obj = {
          excelContentList: excelContentList,
          excelTitleList: excelTitleList
        };
        let newTab = window.open('about:blank');
        v.axios.post(api.post_packageInfo_exportPackingPrintingExcel, obj).then(response => {
          if (response.data.code === 0) {
            newTab.location.href = filenodeViewTargetUrl + response.data.datas;
            setTimeout(function () {
              newTab.close();
            }, 1000);
          } else {
            newTab.close();
          }
        });
      }
    },
    startImportExcel(val) {
      // 打印前作废 导出
      let v = this;
      let obj = {};
      let filenodeViewTargetUrl = localStorage.getItem('imgUrlPrefix');
      if (val) {
        if (!v.cancelGoodsData) {
          v.$Message.error('no data！');
          return false;
        }
        // 组装数据
        let excelContentList = []; // 数据
        let excelTitleList = [// 表头
          {
            title: 'No',
            column: 'no'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
            column: 'goodsTotal'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
            column: 'goodsNum'
          }
        ];
        let pos = [];
        v.cancelGoodsData.forEach((n, i) => {
          pos.push([
            {
              column: 'no',
              content: i + 1
            }, {
              column: 'goodsTotal',
              content: n.sku
            }, {
              column: 'goodsNum',
              content: n.quantity
            }
          ]);
        });
        pos.forEach((m, t) => {
          excelContentList.push({
            excelColumnContentList: m
          });
        });
        obj = {
          excelContentList: excelContentList,
          excelTitleList: excelTitleList
        };
        let newTab = window.open('about:blank');
        v.axios.post(api.post_packageGoods_exportPackingUnPrintSkusExcel, obj).then(response => {
          if (response.data.code === 0) {
            newTab.location.href = filenodeViewTargetUrl + response.data.datas;
            setTimeout(function () {
              newTab.close();
            }, 1000);
          } else {
            newTab.close();
          }
        });
      } else {
        if (!v.cancelData.length) {
          v.$Message.error('no data！');
          return false;
        }
        // 组装数据
        let excelContentList = []; // 数据
        let excelTitleList = [// 表头
          {
            title: 'No',
            column: 'no'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000156'),
            column: 'pickNo'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
            column: 'followNo'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004847'),
            column: 'buyerName'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004852'),
            column: 'goodsMes'
          }
        ];
        let pos = [];
        let box = [];
        v.cancelData.forEach((n, i) => {
          if (v.cancelGoodsData) {
            v.cancelGoodsData.forEach((v, p) => {
              if (v.packageCode === n.packageCode) {
                let item = v.sku + ' * ' + v.quantity;
                box.push(item);
              }
            });
          }
          pos.push([
            {
              column: 'no',
              content: i + 1
            }, {
              column: 'pickNo',
              content: n.packageCode
            }, {
              column: 'followNo',
              content: n.trackingNumber
            }, {
              column: 'buyerName',
              content: n.buyerName
            }, {
              column: 'goodsMes',
              content: box.toString()
            }
          ]);
        });
        pos.forEach((m, t) => {
          excelContentList.push({
            excelColumnContentList: m
          });
        });
        obj = {
          excelContentList: excelContentList,
          excelTitleList: excelTitleList
        };
        let newTab = window.open('about:blank');
        v.axios.post(api.post_packageInfo_exportPackingUnPrintExcel, obj).then(response => {
          if (response.data.code === 0) {
            newTab.location.href = filenodeViewTargetUrl + response.data.datas;
            setTimeout(function () {
              newTab.close();
            }, 1000);
          } else {
            newTab.close();
          }
        });
      }
    },
    endImportExcel(val) {
      // 打印后作废 导出
      let v = this;
      let obj = {};
      let filenodeViewTargetUrl = localStorage.getItem('imgUrlPrefix');
      if (val) {
        if (!v.cancelPrintGoodsData) {
          v.$Message.error('no data！');
          return false;
        }
        // 组装数据
        let excelContentList = []; // 数据
        let excelTitleList = [// 表头
          {
            title: 'No',
            column: 'no'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
            column: 'goodsTotal'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
            column: 'goodsNum'
          }
        ];
        let pos = [];
        v.cancelPrintGoodsData.forEach((n, i) => {
          pos.push([
            {
              column: 'no',
              content: i + 1
            }, {
              column: 'goodsTotal',
              content: n.sku
            }, {
              column: 'goodsNum',
              content: n.quantity
            }
          ]);
        });
        pos.forEach((m, t) => {
          excelContentList.push({
            excelColumnContentList: m
          });
        });
        obj = {
          excelContentList: excelContentList,
          excelTitleList: excelTitleList
        };
        let newTab = window.open('about:blank');
        v.axios.post(api.post_packageGoods_exportPackingInvalidSkusExcel, obj).then(response => {
          if (response.data.code === 0) {
            newTab.location.href = filenodeViewTargetUrl + response.data.datas;
            setTimeout(function () {
              newTab.close();
            }, 1000);
          } else {
            newTab.close();
          }
        });
      } else {
        if (!v.cancelPrintData.length) {
          v.$Message.error('no data！');
          return false;
        }
        // 组装数据
        let excelContentList = []; // 数据
        let excelTitleList = [// 表头
          {
            title: 'No',
            column: 'no'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000156'),
            column: 'pickNo'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
            column: 'followNo'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004847'),
            column: 'buyerName'
          }, {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004852'),
            column: 'goodsMes'
          }
        ];
        let pos = [];
        let box = [];
        v.cancelPrintData.forEach((n, i) => {
          if (v.cancelGoodsData) {
            v.cancelGoodsData.forEach((v, p) => {
              if (v.packageCode === n.packageCode) {
                let item = v.sku + ' * ' + v.quantity;
                box.push(item);
              }
            });
          }
          pos.push([
            {
              column: 'no',
              content: i + 1
            }, {
              column: 'pickNo',
              content: n.packageCode
            }, {
              column: 'followNo',
              content: n.trackingNumber
            }, {
              column: 'buyerName',
              content: n.buyerName
            }, {
              column: 'goodsMes',
              content: box.toString()
            }
          ]);
        });
        pos.forEach((m, t) => {
          excelContentList.push({
            excelColumnContentList: m
          });
        });
        obj = {
          excelContentList: excelContentList,
          excelTitleList: excelTitleList
        };
        let newTab = window.open('about:blank');
        v.axios.post(api.post_packageInfo_exportPackingInvalidExcel, obj).then(response => {
          if (response.data.code === 0) {
            newTab.location.href = filenodeViewTargetUrl + response.data.datas;
            setTimeout(function () {
              newTab.close();
            }, 1000);
          } else {
            newTab.close();
          }
        });
      }
    },
  }
};
</script>

<style scoped>
.title {
  padding: 20px 0;
}

.red {
  color: red;
}

.ml10 {
  margin-left: 10px;
}
</style>
